import { randomId } from '../util/strings';
import { useConst } from './useConst';

export const useId = (prefix?: string): string => {
    const id = (prefix || 'id') + randomId(8);
    return useConst(id);
};
